import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'; 
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { SessionExpired } from '../apis/api/SignupApi';

const isTokenExpired = (token) => {
  if (!token) return true; 
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; 
    return decodedToken.exp < currentTime; 
  } catch (error) {
    return true; 
  }
};

const clearAllCookies = () => {
  const allCookies = Cookies.get();
  Object.keys(allCookies).forEach(cookie => {
    Cookies.remove(cookie);
  });
  
};

const ProtectedRoute = () => {
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");
  const company_id = Cookies.get("company_id");

  const expired = !token || isTokenExpired(token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [handlingSession, setHandlingSession] = React.useState(false);

  useEffect(() => {
    if (expired && !handlingSession) {
      setHandlingSession(true);

      dispatch(SessionExpired({ userId, companyId: company_id }))
        .finally(() => {
          clearAllCookies();
          toast.error("Session Expired!");
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 1000);
        });
    }
  }, [expired, handlingSession, userId, company_id, dispatch, navigate]);


  if (handlingSession) {
    return null; 
  }


  if (token && userId && !expired) {
    return <Outlet />;
  }


  return <Navigate to="/" replace />;
};


export default ProtectedRoute;